import React, { ReactNode } from 'react';
import { Container, Flex, Spacer } from '@chakra-ui/react';
import NavBarSimple from './NavBarSimple';
import Footer from './Footer';

type Props = {
  children: ReactNode;
};

function LayoutNoLogin({ children }: Props) {
  return (
    <Flex minH="100vh" direction="column" overflowX="hidden">
      <NavBarSimple />
      <Container pt={[24, null, null, 28]} pb={16}>
        {children}
      </Container>
      <Spacer />
      <Footer />
    </Flex>
  );
}

export default LayoutNoLogin;
